// Auto-refactored from translations.js on 2026-08-19
// Locale: sl

const sl = {
  wieMoeglich: { question: 'Kako je to mogoče?', answer: 'Na novo smo zasnovali verigo vrednosti.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Pot STIG ROCK',
    fazit: 'Skrajšana dobavna veriga odpravi največje stroškovne postavke.',
    fazitBigPre: 'To omogoča popust do',
    fazitBigValue: '80%',
    steps: [ 'Rudnik', 'Brusilnica', 'Certificiranje', 'Končni kupec' ]
  },
  nav: { language: 'Jezik', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Edinstvena priložnost',
    subtitle: 'Gradnja premoženja, usmerjena v prihodnost.',
    description: 'STIG ROCK je mednarodna platforma, ki ljudem omogoča dostop do naravnih diamantov, trajnostne gradnje premoženja in edinstvene skupnosti.',
    scroll: 'Pomaknite se navzdol za odkrivanje'
  },
  disclaimer: {
    overline: 'Pravno obvestilo',
    title: 'Disclaimer',
    paragraphs: [
      'Ta predstavitev je zgolj informativne narave in ne predstavlja finančnega, naložbenega ali davčnega svetovanja.',
      'STIG ROCK ni finančni produkt, temveč se nanaša na naravne diamante kot stvarna sredstva.',
      'Za razvoj vrednosti, dobičke ali donose ni nobenega jamstva. Pretekli razvoj ni pokazatelj prihodnjih rezultatov.',
      'Vsi prikazani izračuni v povezavi s provizijami so zgolj primeri in prav tako ne predstavljajo jamstva.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'ZGRAJENO', 'NA STRUKTURI' ],
    body: 'STIG GROUP je mednarodni koncern, zgrajen na jasnosti, odgovornosti in dolgoročni vrednosti. Vsaka blagovna znamka, vsak podvig in vsako partnerstvo sledi enemu samemu standardu — brez bližnjic, brez izjem.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'ZGRAJENO', 'NA STRUKTURI' ],
        body: 'STIG GROUP je mednarodni koncern, zgrajen na jasnosti, odgovornosti in dolgoročni vrednosti. Vsaka blagovna znamka, vsak podvig in vsako partnerstvo sledi enemu samemu standardu — brez bližnjic, brez izjem.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'SVET', 'EKSKLUZIVNIH DIAMANTOV' ],
        body: 'STIG ROCK je sodoben koncept STIG GROUP, ki združuje visokokakovostne diamante s certifikatom GIA s transparentnimi strukturami in ekskluzivno uporabniško izkušnjo. Jasni načrti rešitev, strokovna izvedba in mednarodna usmerjenost.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'MEDNARODNA', 'TRGOVINA Z DIAMANTI' ],
        body: 'STIG International je del STIG GROUP in je specializiran za mednarodno trgovino z diamanti s certifikatom GIA. Fokus na kakovosti, zaupanju in sodobnih trgovskih strukturah z globalnimi partnerstvi.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ODGOVORNOST', 'ŽE OD RUDNIKA' ],
        body: 'Ethical Mines pomeni odgovorno rudarjenje, sledljivo poreklo in diamante brez konfliktov. Od rudnika do trga — popolna dokumentacija za transparentnost, integriteto in dolgoročno odgovornost vzdolž celotne dobavne verige.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamanti',
    stigDrawback: 'Realna hramba vrednosti',
    overline: 'Možnosti',
    title: 'Možnosti za gradnjo premoženja',
    subtitle: 'Primerjava običajnih poti.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex ali Krypto',
        drawback: 'visoko spekulativno, nepredvidljivo, kompleksno'
      },
      {
        tag: 'Aktien',
        name: 'Borzno trgovanje',
        drawback: 'tveganje nihanja, zahtevano znanje, časovna potratnost'
      },
      {
        tag: 'Krypto',
        name: 'Trgovanje',
        drawback: 'volatilnost, regulativno tveganje, varnostne pomanjkljivosti'
      }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: 'Podcenjena priložnost',
    body: 'Diamondi že leta spadajo med naložbene oblike z najbolj stabilno vrednostjo in največ priložnostmi, vendar je ta potencial doslej izkoristilo le malo ljudi.',
    callout: 'Z našo platformo STIG ROCK prvič vsem odpiramo dostop do teh izjemnih možnosti.'
  },
  wertentwicklung: {
    overline: 'Razvoj vrednosti 1995 — 2025',
    title: 'Zgodba o vrednosti.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'Razvoj od 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Glavni razlogi',
    title: 'Šest razlogov za Diamond',
    lead: 'Diamondi so realna stvarna sredstva, ki obstajajo neodvisno od valut in finančnih sistemov — in že stoletja ohranjajo svojo vrednost.',
    items: [
      {
        n: '01',
        title: 'Varnost pred krizo',
        body: 'Garancija stvarne vrednosti. Neodvisno od valut in finančnih sistemov.'
      },
      {
        n: '02',
        title: 'Vrhunska mobilnost',
        body: 'Majhni, lahki za shranjevanje in transport.'
      },
      {
        n: '03',
        title: 'Diverzifikacija & pomanjkanje',
        body: 'Omejena ponudba in naravna omejenost.'
      },
      { n: '04', title: 'Dolgoročna rast', body: '+185% od leta 1995.' },
      {
        n: '05',
        title: 'Transparentnost & ekskluzivnost',
        body: '4 Cʼs kot garancija: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Rezerva kraljevih hiš',
        body: 'Tudi kraljeve hiše uporabljajo Diamond kot rezervo premoženja.'
      }
    ]
  },
  markt: {
    overline: 'Tržni volumen',
    title: '99 — 108 Mrd. USD',
    sub: 'Obseg trgovanja v letu 2025',
    forecast: 'Napoved do ~2032 / 2034: pribl. 140 – 168 Mrd. USD ob zmerni rasti (~4 – 5 % p.a.).',
    source: 'Vir: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Inovacija',
    title: 'Inovacija. Prvič na svetu.',
    body: 'STIG ROCK je prva platforma na svetu, ki ljudem omogoča ustvarjanje pasivnega dohodka na trgu diamantov poleg rasti vrednosti.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Register-št. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'O podjetju',
    titleLines: [ 'MEDNARODNA', 'STRUKTURA', 'JASNA VIZIJA' ],
    body: 'STIG ROCK je bil ustanovljen z namenom, da trg diamantov naredi bolj transparenten, sodoben in usmerjen h kupcem — s poudarkom na zaupanju, varnosti in dolgoročni strukturi.'
  },
  sicherheit: {
    overline: 'Kakovost & varnost',
    title: 'Gemological Institute of America',
    body: 'Certificirano strokovno znanje za vaše diamante. GIA ocenjuje vsak kamen z najvišjo natančnostjo in dolgoletnimi izkušnjami — zanesljive cenitve za naše podjetje in naše stranke.',
    transparency: 'Vsak Diamond izpolnjuje najvišje standarde kakovosti in je preverjen ter certificiran s strani priznanih organizacij. Vsak kamen je edinstven in prejme individualni certifikat.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Edinstvena produktna inovacija',
    sub: 'Šest stopenjskih Solution Pläne — od $1K do $100K+, vsak z naraščajočim popustom na mesec in čez celotno obdobje.',
    recommended: 'Priljubljeno',
    oneYear: '1 leto',
    rowLabels: {
      delivery: 'Čas dostave',
      price: 'Cena produkta',
      carat: 'Carat',
      monthly: 'Popust (mesec)',
      totalDiscount: 'Popust (skupaj)',
      duration: 'Trajanje'
    },
    headers: {
      plan: 'Plan',
      from: 'Od',
      carat: 'Carat',
      monthly: 'Popust / mesec',
      total: 'Popust skupaj',
      duration: 'Trajanje'
    },
    duration: '1 leto',
    footnote: 'Vsi podatki o cenah so brez jamstva in odvisni od kakovosti, povpraševanja in trenutnega tržnega razvoja. Solution načrti so možni tudi za 2 leti.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + VIP-Paket',
    title: 'Več prednosti z VIP-Paket',
    sub: 'Kombiniraj svoj Solution Plan z VIP-Paket in izkoristi dodatne cenovne prednosti do 3 %. Tako povečaš svoj skupni popust in si zagotoviš še bolj privlačne pogoje.',
    rowLabels: {
      delivery: 'Čas dostave',
      price: 'Cena produkta',
      carat: 'Carat',
      monthly: 'Popust (mesec)',
      totalDiscount: 'Popust (skupaj)',
      vip1: 'VIP-paket 1 (+1%)',
      vip2: 'VIP-paket 2 (+2%)',
      vip3: 'VIP-paket 3 (+3%)'
    },
    footnote: 'Vsi podatki o cenah so brez jamstva in odvisni od kakovosti, povpraševanja in trenutnega tržnega razvoja.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Več prednosti z VIP-Paket',
    sub: 'Kombiniraj svoj Solution Plan z VIP-Paket in izkoristi dodatne cenovne prednosti do 3 %. Tako povečaš svoj skupni popust in si zagotoviš še bolj privlačne pogoje.',
    options: [
      {
        key: 'deliver',
        title: 'Več prednosti z VIP-Paket',
        body: 'Diamond (Carat) po ceni vašega DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Prodaja nam',
        body: 'Svoje diamante nam lahko prodate nazaj po nakupni ceni, ki ste jo plačali.'
      },
      {
        key: 'sellThirdParty',
        title: 'Prodaja tretjim osebam',
        body: 'Svoje diamante lahko prodate tretjim osebam na prostem trgu.'
      }
    ],
    footnote: '*DS-Plan pomeni Solution Plan.'
  },
  tradWeg: {
    overline: 'Tradicionalna trgovina',
    title: 'Tradicionalna pot',
    sub: 'Preden Diamond doseže končnega kupca, nastanejo zaradi posrednikov, veleprodaje in maloprodaje znatne trgovske marže v primerjavi s ceno surovih diamantov iz rudnika.',
    steps: [
      { title: 'Rudnik', subtitle: 'Surovi Diamondi' },
      { title: 'Posrednik', subtitle: 'Nakup surovih diamantov' },
      { title: 'Brusilnica', subtitle: 'Brušenje v nakitne diamante' },
      { title: 'Certificiranje', subtitle: 's strani priznanih institutov kot je GIA' },
      { title: 'Borza diamantov', subtitle: 'Prodaja veleprodaji' },
      { title: 'Veleprodaja', subtitle: 'Prodaja maloprodaji' },
      { title: 'Maloprodaja', subtitle: 'npr. draguljarji' },
      { title: 'Končni kupci', subtitle: 'Nakup diamantov' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-Paketi',
    sub: 'Velja 12 mesecev za vse vaše sklenjene Solution načrte. Odvisno od VIP-paketa: +1% do +3% dodatnega popusta',
    cardKicker: 'dodatno – na vse',
    cardKicker2: 'Solution načrte',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Iz popustov nastanejo prihranki',
      body: 'Mesečni prihranek namesto mesečne obremenitve. Iz popustov nastanejo prihranki – in ti plačajo prav tiste stvari, za katere sicer vsak mesec plačujete iz lastnega žepa.',
      line1Label: 'DS-Plan od',
      line1Value: '$5.000',
      line2Label: 'mes. popust',
      line2Value: '3%',
      line3Label: 'VIP-Paket 3',
      line3Value: '+3%',
      resultLabel: 'mes. prihranki',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Kako je to mogoče?',
    title: 'Na novo smo zasnovali verigo ustvarjanja vrednosti.',
    traditionalTitle: 'Tradicionalna pot',
    traditionalSteps: [
      'Rudnik — Surovi Diamondi',
      'Posrednik — Nakup',
      'Brusilnica — Brušenje',
      'Certificiranje (GIA)',
      'Borza diamantov — Veleprodaja',
      'Veleprodaja → Maloprodaja',
      'Draguljarji → Končni kupec'
    ],
    traditionalNote: 'Preden Diamond doseže končnega kupca, nastanejo zaradi posrednikov, veleprodaje in maloprodaje znatne trgovske marže.',
    stigTitle: 'Pot STIG ROCK',
    stigSteps: [
      'Neposreden nakup — Surovi Diamondi iz rudnika',
      'Brušenje & certificiranje preko naših Partner-jev',
      'Prodaja končnim kupcem & B2B strankam',
      'Do 4 trgovalni cikli na leto'
    ],
    stigNote: 'Prekinemo krog in trgovske marže prenesemo na naše stranke kot dobropise popustov — do 4 trgovalni cikli v času trajanja DS-Plan.'
  },
  optionen: {
    overline: 'Vaše možnosti',
    title: 'Po izteku vašega Solution načrta',
    items: [
      { title: 'Dostava na dom', body: 'Diamond (Carat) po ceni vašega DS-Plan.' },
      {
        title: 'Prodaja nam',
        body: 'Povratna prodaja po nakupni ceni, ki ste jo plačali.'
      },
      { title: 'Prodaja tretjim osebam', body: 'Prodaja diamantov na prostem trgu.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution načrti — edinstvena produktna inovacija',
    title: 'Preprosta pot',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Prijava',
        body: 'Kontaktirajte svojo priporočiteljsko osebo in ustvarite brezplačen račun!'
      },
      { n: '02', icon: 'cart', title: 'Nakup produkta', body: 'Že od $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Prejemanje popustov',
        body: 'Prejemajte mesečne dobropise popustov.'
      }
    ]
  },
  business: {
    overline: 'Vrste bonusov',
    title: 'Najpreprostejša in najpravičnejša pot.',
    sub: 'Pet vrst bonusov — za vašo uspešno gradnjo posla.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Do ravni 3, od stopnje Pearl / Ruby naprej.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Od Sapphire naprej — neskončno globoko.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Na Infinity Bonus – do ravni 5 · BREZ kvalifikacij.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 skladi svetovnega prometa.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Enkratni bonus v diamantih (Carat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Ta bonus vam je izplačan za vsak na novo sklenjen Solution načrt do 3. ravni. Posamezne ravni odklenete z zelo nizkimi kvalifikacijami.',
    total: 'Do 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'od samega začetka',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'od stopnje Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'od stopnje Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Od stopnje Sapphire ste kvalificirani za naš Infinity Bonus načrt. Prejmete 3% bonusa. Z vsako novo stopnjo se dodajo novi odstotki. Če je Partner v vaši ekipi prav tako kvalificiran, prejmete razliko med stopnjama.',
    exampleTitle: 'Primer',
    exampleRows: [
      { label: 'Ste Blue Diamond', value: '12%' },
      { label: 'Vaš Partner je Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Vaš Infinity Bonus', value: '9%' },
    totalNote: 'Skupaj do 24% Infinity Bonus na vse sklenjene Solution načrte v vaši ekipi — neskončno globoko.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'S tem bonusom profitirate od uspeha vaše ekipe. Prejmete Matching Bonus v višini 5% na Infinity Bonus vaših Partner-jev — in to vse do 5. ravni vaše ekipe.',
    note: 'Na vsa izplačila Infinity Bonus v vaši ekipi – do 5. ravni. Od samega začetka – BREZ kvalifikacij.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Skupaj do',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% svetovnega prometa se v enakih delih steče v 3 različne sklade. Z doseganjem določenih stopenj se kvalificirate za vsak posamezen sklad.',
    forever: 'Enkrat doseženo – za VEDNO udeleženi!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'od Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'od Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'od Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Skupaj',
    totalValue: '3%',
    totalSuffix: 'svetovnega prometa'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Od stopnje Diamond naprej prejmete Rang Bonus. Ta je izplačan v diamantih (Carat). Pri tem gre za enkratni bonus.',
    highlight: 'Diamondi (Carat) v skupni vrednosti',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: 'Stopnje',
    sub: 'Za doseganje posameznih stopenj šteje zgodovinski skupni promet (HG). Ta mora biti od stopnje Sapphire naprej porazdeljen na več ekip. Za dosego Ruby ali višje potrebujete vsaj dva direktna Partner-ja s STIG ROCK načrtom.',
    forever: 'Enkrat doseženo – VEDNO potrjeno!',
    footnote: 'HV = Historisches Volumen.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Začnite z nami',
    title: 'Pravi čas je prav zdaj.',
    body: 'Ta poslovni model postavlja nova merila in združuje vse faktorje uspeha za dolgoročno trajnostno in uspešno poslovanje. Registrirajte se še danes, izberite svoj Solution načrt in izkoristite to edinstveno poslovno priložnost.',
    hint: 'Govorite z osebo, ki vas je povabila na to predstavitev — ona ima za vas povezavo za registracijo.',
    formName: 'Ime',
    formEmail: 'E-pošta',
    formPhone: 'Telefon',
    formSubmit: 'Stopite v stik',
    success: 'Hvala — odzvali se bomo diskretno in osebno.',
    callCta: 'Pokliči',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Pravno obvestilo & Disclaimer',
    disclaimer: 'Ta predstavitev je zgolj informativne narave in ne predstavlja finančnega, naložbenega ali davčnega svetovanja. STIG ROCK ni finančni produkt, temveč se nanaša na naravne diamante kot stvarna sredstva. Za razvoj vrednosti, dobičke ali donose ni nobenega jamstva. Pretekli razvoj ni pokazatelj prihodnjih rezultatov. Vsi prikazani izračuni v povezavi s provizijami so zgolj primeri in prav tako ne predstavljajo jamstva. Pridržujemo si pravico do sprememb vsebine — prost prevod (ni uradni prevod).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Vse pravice pridržane.',
    version: 'Verzija: DS-12-2025 V3'
  },
  misc: { next: 'Naslednji razdelek' }
};

export default sl;
